import { ActivatedRoute } from '@angular/router';
import { Partners } from '@lockton-apps/shared/interfaces';
import { toInteger } from 'lodash';
import { ProposalsStepCustomizerService } from './services/proposals-step-customizer.service';

export function routedPortalStepCustomizerFactory(
  activatedRoute: ActivatedRoute
): ProposalsStepCustomizerService {
  const routedPortalId: Partners = toInteger(
    activatedRoute.snapshot.paramMap.get('portalId')
  );

  switch (routedPortalId) {
    default:
      return new ProposalsStepCustomizerService();
  }
}
